module.exports = __webpack_public_path__ + "static/media/avatar2.d1be9174.png";